<template>
  <div class="priceDetail__item">
    <header class="priceDetail__itemHeader">{{ $t(headerLabel) }}</header>
    <section class="priceDetail__itemMain">
      <span class="priceDetail__itemMain--amount">{{
        price | amountFormatPipe
      }}</span>
      <span class="priceDetail__itemMain--currency">{{ currency }}</span>
    </section>
    <slot />
  </div>
</template>
<script>
import filters from '../helpers/filters'
export default {
  name: 'PriceDetailItem',
  props: {
    price: null,
    currency: null,
    headerLabel: null,
  },
  mixins: [filters],
}
</script>
